import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import style from "css/realtime.module.css";
import moment from "moment-timezone";
import {
  Descriptions,
  Button,
  ConfigProvider,
  Table,
  Modal,
  QRCode,
  Empty,
} from "antd";
import {
  PoweroffOutlined,
  ReloadOutlined,
  AudioOutlined,
  AudioMutedOutlined,
  DisconnectOutlined,
  AppstoreOutlined,
  ExportOutlined,
  CopyOutlined,
  QrcodeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { openConfirm, closeAlert, openAlert } from "redux/slices/alertSlice";
import LayoutImg from "./layoutImg";
import RealtimeEndpointModal from "./realtimeEndpointModal";
import CopyToClipboard from "react-copy-to-clipboard";
import AddEndpointModal from "./addEndpointModal";
import { useTranslation } from "react-i18next";

function RealtimeDetail(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [participantId, setParticipantId] = useState("");
  const [openLayoutModal, setOpenLayoutModal] = useState(false);
  const closeLayoutModal = () => {
    setOpenLayoutModal(false);
  };
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const closeDetailModal = () => {
    setOpenDetailModal(false);
    setParticipantId("");
  };

  const [openAddEndpointModal, setOpenAddEndpointModal] = useState(false);
  const closeAddEndpointModal = () => {
    setOpenAddEndpointModal(false);
  };

  const pexipColumns = [
    {
      title: t("LIST.DEVICE_NAME"),
      dataIndex: "display_name",
      key: "display_name",
      align: "center",
    },
    {
      title: t("LIST.DEVICE_IP"),
      dataIndex: "signalling_node",
      key: "signalling_node",
      align: "center",
    },
    {
      title: t("LIST.MUTE"),
      dataIndex: "is_muted",
      key: "is_muted",
      align: "center",
      render: (_, el) =>
        el.is_muted ? (
          // <AudioOutlined style={{ color: "#1677ff" }} />
          <AudioMutedOutlined
            style={{
              color: "#1cb691",
              transform: "scaleX(-1)",
            }}
            onClick={() => setMute(el.id, !el.is_muted)}
          />
        ) : (
          <AudioOutlined
            // style={{ color: "#1677ff" }}
            onClick={() => setMute(el.id, !el.is_muted)}
          />
        ),
    },
    {
      title: t("LIST.DISCONNECT"),
      dataIndex: "DISCONNECT",
      key: "DISCONNECT",
      align: "center",
      render: (_, el) => (
        <DisconnectOutlined
          style={{ color: "#f5222d" }}
          onClick={() => {
            const obj = {
              title: t("MESSAGE.NOTIFICATION"),
              content: t("MESSAGE.DISCONNECT_USER", { USER: el.display_name }),
              submitEventHandler: () => {
                setDisconnect(el.id);
                dispatch(closeAlert());
              },
            };
            dispatch(openConfirm(obj));
          }}
        />
      ),
    },
    {
      title: t("LIST.CONNECTION_TIME"),
      dataIndex: "connect_time",
      key: "connect_time",
      align: "center",
      render: (_, el) =>
        moment
          .utc(el.connect_time)
          .tz(meetingDetail.SCHEDULE_INFO.UNLOCODE)
          .format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: t("LIST.DETAIL_INFO"),
      dataIndex: "DETAIL",
      key: "DETAIL",
      align: "center",
      render: (_, el) => (
        <>
          <ConfigProvider
            theme={{
              token: {
                fontFamily: "Spoqa Han Sans Neo",
              },
              components: {
                Button: {
                  colorPrimary: "#def5e9",
                  colorTextLightSolid: "#1cb691",
                  // colorPrimaryText: "#1cb691",
                  colorPrimaryHover: "#def5e9",
                  // colorPrimaryActive: "#003eb3",
                },
              },
            }}
          >
            <Button
              type="primary"
              shape="round"
              onClick={() => (
                setOpenDetailModal(true), setParticipantId(el.id)
              )}
            >
              {t("BTN.MORE")}
              <PlusOutlined />
            </Button>
          </ConfigProvider>
        </>
      ),
    },
  ];

  const [loading, setLoading] = useState(false);
  const [meetingDetail, setMeetingDetail] = useState({
    ENVIRONMENT_INFO: {},
    CALL_INFO: {},
    MEETING_ROOM_INFO: {},
    SCHEDULE_INFO: {},
    PARTICIPANTS: [],
  });

  const getMeetingDetail = useCallback(() => {
    let url = "/active/detail";
    let param = {
      params: {
        MEETING_KEY: props.meetingKey,
      },
    };
    setLoading(true);
    axios.get(url, param).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        if (res.data.hasOwnProperty("ERR_MSG")) {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.ALREADY_ENDED_MEETING"),
            submitEventHandler: () => {
              dispatch(closeAlert());
              navigate(-1);
            },
          };
          dispatch(openAlert(obj));
        } else {
          setMeetingDetail(res.data);
        }
      } else {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ALREADY_ENDED_MEETING"),
          submitEventHandler: () => {
            dispatch(closeAlert());
            navigate(-1);
          },
        };
        dispatch(openAlert(obj));
      }
    });
  }, [dispatch, navigate, props.meetingKey]);

  const setMute = (id, mute) => {
    let url = "/active/mute";
    let param = {
      params: {
        MEETING_KEY: props.meetingKey,
        PARTICIPANT: id,
        MUTE: mute,
      },
    };
    setMeetingDetail({
      ...meetingDetail,
      PARTICIPANTS: [],
    });
    setLoading(true);
    axios.post(url, null, param).then((res) => {
      if (res.status === 200) {
        if (res.data.PARTICIPANTS !== null) {
          setLoading(false);
          setMeetingDetail({
            ...meetingDetail,
            PARTICIPANTS: res.data.PARTICIPANTS,
          });
        }

        // getMeetingDetail();
      }
    });
  };

  const setMuteAll = () => {
    let url = "/active/muteAll";

    let particiapntArr = [];
    for (let i = 0; i < meetingDetail.PARTICIPANTS.length; i++) {
      let id = meetingDetail.PARTICIPANTS[i].id;
      particiapntArr.push(id);
    }

    let param = {
      params: {
        MEETING_KEY: props.meetingKey,
        PARTICIPANT: particiapntArr.toString().trim(),
      },
    };
    setMeetingDetail({
      ...meetingDetail,
      PARTICIPANTS: [],
    });
    setLoading(true);
    axios.post(url, null, param).then((res) => {
      if (res.status === 200) {
        if (res.data.PARTICIPANTS !== null) {
          setLoading(false);
          setMeetingDetail({
            ...meetingDetail,
            PARTICIPANTS: res.data.PARTICIPANTS,
          });
        }
      }
    });
  };

  const setDisconnect = (id) => {
    let url = "/active/disconnect";
    let param = {
      params: {
        MEETING_KEY: props.meetingKey,
        PARTICIPANT: id,
      },
    };
    setMeetingDetail({
      ...meetingDetail,
      PARTICIPANTS: [],
    });
    setLoading(true);
    axios.post(url, null, param).then((res) => {
      if (res.status === 200) {
        if (res.data.PARTICIPANTS !== null) {
          setLoading(false);
          setMeetingDetail({
            ...meetingDetail,
            PARTICIPANTS: res.data.PARTICIPANTS,
          });
        }

        // getMeetingDetail();
      }
    });
  };

  const changeMeetingLayout = (layout) => {
    closeLayoutModal();
    let url = "/active/layout";
    let param = {
      params: {
        MEETING_KEY: meetingDetail.CALL_INFO.id,
        LAYOUT: layout,
      },
    };

    axios.post(url, null, param).then((res) => {
      if (res.status === 200) {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.LAYOUT_CHANGED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      }
    });
  };

  const disconnectMeetingRoom = () => {
    let url = "/active/disconnectMeeting";
    let param = {
      params: {
        MEETING_KEY: props.meetingKey,
        CALL_ID: meetingDetail.CALL_INFO.id,
        ROOM_ID: meetingDetail.MEETING_ROOM_INFO.id,
      },
    };

    axios.post(url, null, param).then((res) => {
      if (res.status === 200) {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.MEETING_ENDED"),
          submitEventHandler: () => {
            navigate(process.env.REACT_APP_CLIENT_URL + "app/realtime");
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      }
    });
  };

  useEffect(() => {
    if (props.meetingKey !== "") {
      getMeetingDetail();
    }
  }, [getMeetingDetail, props.meetingKey]);

  const [openPop, setopenPop] = useState(false);
  const closePop = () => {
    setopenPop(false);
  };

  return (
    <>
      <RealtimeEndpointModal
        id={participantId}
        open={openDetailModal}
        close={closeDetailModal}
      />

      {openAddEndpointModal ? (
        <AddEndpointModal
          open={openAddEndpointModal}
          close={closeAddEndpointModal}
        />
      ) : (
        <></>
      )}

      <Modal
        centered
        className={style.qrpop_full} //모달 ClassName
        open={openPop}
        onCancel={closePop}
        footer={null}
        width="auto"
      >
        <QRCode
          errorLevel="H"
          value={meetingDetail.SCHEDULE_INFO.MEETING_URL}
          icon="https://demo.riv-tech.co.kr/allplace/img/mypage/logo.png"
          iconSize={150}
          size={800}
        />
        <div
          style={{ fontSize: "22px", textAlign: "center", marginTop: "5px" }}
        >
          MEETING URL : {meetingDetail.SCHEDULE_INFO.MEETING_URL}
        </div>
      </Modal>

      <div className={style.wrapper}>
        <div className={style.content_area}>
          <div className={style.header}>
            <div>{t("LABEL.TITLE.MEETING_DETAILS")}</div>
            <div className={style.btn_area}>
              <ConfigProvider
                theme={{
                  token: {
                    fontFamily: "Spoqa Han Sans Neo",
                  },
                  components: {
                    Button: {
                      colorPrimary: "#1677ff",
                      colorPrimaryHover: "#1cb691",
                      colorPrimaryActive: "#1cb691",
                    },
                  },
                }}
              >
                <Button
                  size="large"
                  // type="ghost"
                  icon={<ExportOutlined />}
                  onClick={() => navigate(-1)}
                >
                  {t("BTN.BACK_TO_LIST")}
                </Button>
              </ConfigProvider>
              <div className={style.ctrl_btn_area}>
                <ConfigProvider
                  theme={{
                    token: {
                      fontFamily: "Spoqa Han Sans Neo",
                    },
                    components: {
                      Button: {
                        colorPrimary: "#1677ff",
                        colorPrimaryHover: "#1cb691",
                        colorPrimaryActive: "#1cb691",
                      },
                    },
                  }}
                >
                  <Button
                    size="large"
                    // type="primary"
                    icon={<ReloadOutlined />}
                    onClick={getMeetingDetail}
                  />
                </ConfigProvider>
                <ConfigProvider
                  theme={{
                    token: {
                      fontFamily: "Spoqa Han Sans Neo",
                    },
                    components: {
                      Button: {
                        colorPrimaryText: "#ffffff",
                        colorTextLightSolid: "#ffffff",
                        colorText: "#ffffff",
                        colorError: "#ff4d4f",
                        colorErrorHover: "#ff7875",
                        colorErrorActive: "#d9363e",
                      },
                    },
                  }}
                >
                  <Button
                    size="large"
                    type="primary"
                    danger
                    icon={<PoweroffOutlined />}
                    onClick={() => {
                      const obj = {
                        title: t("MESSAGE.NOTIFICATION"),
                        content: t("MESSAGE.END_MEETING_CONFIRM"),
                        submitEventHandler: () => {
                          disconnectMeetingRoom();
                          dispatch(closeAlert());
                        },
                      };
                      dispatch(openConfirm(obj));
                    }}
                  >
                    {t("BTN.END_MEETING")}
                  </Button>
                </ConfigProvider>
              </div>
            </div>
          </div>

          <Descriptions bordered column={2} className={style.meeting_info}>
            <Descriptions.Item label={t("LIST.MEETING_TITLE")} span="2">
              {meetingDetail.SCHEDULE_INFO.TITLE}
            </Descriptions.Item>
            <Descriptions.Item label={t("LIST.MEETING_TIME")}>
              {meetingDetail.SCHEDULE_INFO.START_DATE_TIME === undefined ||
                meetingDetail.SCHEDULE_INFO.END_DATE_TIME === undefined
                ? ""
                : meetingDetail.SCHEDULE_INFO.START_DATE_TIME +
                " ~ " +
                meetingDetail.SCHEDULE_INFO.END_DATE_TIME}
            </Descriptions.Item>
            <Descriptions.Item label={t("LIST.MEETING_START")}>
              {meetingDetail.CALL_INFO.start_time === undefined
                ? ""
                : moment
                  .utc(meetingDetail.CALL_INFO.start_time)
                  .tz(meetingDetail.SCHEDULE_INFO.UNLOCODE)
                  .format("YYYY-MM-DD HH:mm:ss")}
            </Descriptions.Item>
            <Descriptions.Item label={t("LABEL.WEB_ACCESS_LINK")} span="2">
              <div className={style.meeting_url_area}>
                <a
                  target="_blank" rel="noreferrer"
                  href={meetingDetail.SCHEDULE_INFO.MEETING_URL}
                >
                  {meetingDetail.SCHEDULE_INFO.MEETING_URL}
                </a>

                <CopyToClipboard
                  className="cursor"
                  text={meetingDetail.SCHEDULE_INFO.MEETING_URL}
                  onCopy={() => {
                    const obj = {
                      title: t("MESSAGE.NOTIFICATION"),
                      content: t("MESSAGE.COPY_COMPLETE"),
                      submitEventHandler: () => {
                        dispatch(closeAlert());
                      },
                    };
                    dispatch(openAlert(obj));
                    return;
                  }}
                >
                  <CopyOutlined
                    style={{
                      fontSize: "16px",
                      color: "#d9d9d9",
                    }}
                  />
                </CopyToClipboard>
                <QrcodeOutlined
                  onClick={() => setopenPop(true)}
                  style={{
                    fontSize: "18px",
                    color: "#c0c0c0",
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label={t("LABEL.ACCESS_NUMBER")}>
              {meetingDetail.SCHEDULE_INFO.MEETING_KEY}
            </Descriptions.Item>
            <Descriptions.Item label={t("LABEL.PASSWORD")}>
              {meetingDetail.SCHEDULE_INFO.MEETING_PW}
            </Descriptions.Item>
          </Descriptions>
        </div>

        <div className={style.content_area}>
          <div className={style.header}>
            <div>{t("LABEL.TITLE.ACCESSED_MEETINGROOM_INFO")}</div>
            <div className={style.btn_meeting_controll_area}>
              <div className={style.btn_meeting_controll}>
                <ConfigProvider
                  theme={{
                    token: {
                      fontFamily: "Spoqa Han Sans Neo",
                    },
                    components: {
                      Button: {
                        // colorPrimary: "#1677ff",
                        colorPrimaryHover: "#1cb691",
                        colorPrimaryActive: "#1cb691",
                      },
                    },
                  }}
                >
                  <Button
                    size="large"
                    icon={
                      <AudioMutedOutlined
                        style={{ transform: "scaleX(-1)", color: "#1cb691" }}
                      />
                    }
                    onClick={() => {
                      const obj = {
                        title: t("MESSAGE.NOTIFICATION"),
                        content: t("MESSAGE.MUTE_ALL_CONFIRM"),
                        submitEventHandler: () => {
                          setMuteAll();
                          dispatch(closeAlert());
                        },
                      };
                      dispatch(openConfirm(obj));
                    }}
                  >
                    {t("BTN.MUTE_ALL")}
                  </Button>
                </ConfigProvider>
                <ConfigProvider
                  theme={{
                    token: {
                      fontFamily: "Spoqa Han Sans Neo",
                    },
                    components: {
                      Button: {
                        // colorPrimary: "#1677ff",
                        colorPrimaryHover: "#1cb691",
                        colorPrimaryActive: "#1cb691",
                      },
                    },
                  }}
                >
                  <Button
                    size="large"
                    icon={<AppstoreOutlined style={{ color: "#1cb691" }} />}
                    onClick={() => setOpenLayoutModal(true)}
                  >
                    {t("BTN.CHANGE_LAYOUT")}
                  </Button>

                  <Modal
                    centered
                    open={openLayoutModal}
                    onCancel={closeLayoutModal}
                    footer={null}
                    width="auto"
                    closable={false}
                  >
                    <div className={style.layoutModal}>
                      <LayoutImg
                        onClick={() => changeMeetingLayout("5:7")}
                        img={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/adaptive_composition.png"
                        }
                        hoverImg={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/adaptive_composition_2.png"
                        }
                      />
                      <LayoutImg
                        onClick={() => changeMeetingLayout("1:7")}
                        img={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/speaker_focused1.png"
                        }
                        hoverImg={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/speaker_focused1_2.png"
                        }
                      />
                      <LayoutImg
                        onClick={() => changeMeetingLayout("1:21")}
                        img={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/speaker_focused2.png"
                        }
                        hoverImg={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/speaker_focused2_2.png"
                        }
                      />
                      <LayoutImg
                        onClick={() => changeMeetingLayout("2:21")}
                        img={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/speaker_focused3.png"
                        }
                        hoverImg={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/speaker_focused3_2.png"
                        }
                      />
                      <LayoutImg
                        onClick={() => changeMeetingLayout("1:33")}
                        img={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/speaker_focused4.png"
                        }
                        hoverImg={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/speaker_focused4_2.png"
                        }
                      />
                      <LayoutImg
                        onClick={() => changeMeetingLayout("1:0")}
                        img={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/Equal1.png"
                        }
                        hoverImg={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/Equal1_2.png"
                        }
                      />
                      <LayoutImg
                        onClick={() => changeMeetingLayout("4:0")}
                        img={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/Equal2.png"
                        }
                        hoverImg={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/Equal2_2.png"
                        }
                      />
                      <LayoutImg
                        onClick={() => changeMeetingLayout("9:0")}
                        img={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/Equal3.png"
                        }
                        hoverImg={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/Equal3_2.png"
                        }
                      />
                      <LayoutImg
                        onClick={() => changeMeetingLayout("16:0")}
                        img={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/Equal4.png"
                        }
                        hoverImg={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/Equal4_2.png"
                        }
                      />
                      <LayoutImg
                        onClick={() => changeMeetingLayout("25:0")}
                        img={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/Equal5.png"
                        }
                        hoverImg={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/layout/Equal5_2.png"
                        }
                      />
                    </div>
                  </Modal>
                </ConfigProvider>
              </div>

              <ConfigProvider
                theme={{
                  token: {
                    fontFamily: "Spoqa Han Sans Neo",
                  },
                }}
              >
                <Button
                  size="large"
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => setOpenAddEndpointModal(true)}
                >
                  {t("BTN.ADD_DEVICE")}
                </Button>
              </ConfigProvider>
            </div>
          </div>

          <Table
            rowKey={(record) => record.id}
            className={style.participant_table}
            loading={loading}
            columns={pexipColumns}
            pagination={false}
            scroll={{
              y: 403,
            }}
            dataSource={meetingDetail.PARTICIPANTS}
            locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
          />
        </div>
      </div>
    </>
  );
}

export default RealtimeDetail;
